export function replaceMustacheVariable(
  template: string,
  variable: string,
  value: string,
): string {
  return template.replace(`{{${variable}}}`, value);
}
